import { EMPTY_LIST } from '../../constants/common'
import {
  DOC_FLOW_PHASE_TITLE_KEYS,
  DOC_FLOW_STATUSES,
  DocFlowRequestLinksField,
  DocFlowTableCellName,
} from '../../constants/docFlow'
import { formatNumberWithSeparators } from '../../utils/number'
import { EntityExtraTagsDocFlowRules } from '../EntityExtraTags'
import {
  TableDateCell,
  TableStatusCell,
  TableTextCell,
  TableTitleCell,
  TableUserCell,
} from '../Table'
import { toUserMultiValue } from '../User'

import { DocFlowTableRowConnectedRequestsCell } from './DocFlowTableRowConnectedRequestsCell'

import DocFlowIcon from '../../icons/doc-splitting.svg'

export function renderCell({ item, name, scrollRef, t, ...restProps }) {
  const { id, [name]: value } = item

  switch (name) {
    case DocFlowTableCellName.CompletedBy:
    case DocFlowTableCellName.CreatedBy:
    case DocFlowTableCellName.UpdatedBy:
      return (
        <TableUserCell
          {...restProps}
          value={value ? toUserMultiValue(value) : null}
        />
      )

    case DocFlowTableCellName.Completed:
    case DocFlowTableCellName.Created:
    case DocFlowTableCellName.Updated:
      return <TableDateCell {...restProps} value={value} />

    case DocFlowTableCellName.ConnectedRequests:
      return (
        <DocFlowTableRowConnectedRequestsCell
          {...restProps}
          count={item[DocFlowRequestLinksField.DocFlowConnectedRequestsCount]}
          docFlowId={id}
          items={value || EMPTY_LIST}
          scrollRef={scrollRef}
        />
      )

    case DocFlowTableCellName.DocumentsCount:
      return <TableTextCell {...restProps} value={value} />

    case DocFlowTableCellName.EpostSpentCredits:
      return (
        <TableTextCell
          {...restProps}
          value={value ? formatNumberWithSeparators(value) : value}
        />
      )

    case DocFlowTableCellName.Name:
      return (
        <TableTitleCell
          {...restProps}
          additionalTooltipInfo={t(
            'DocumentStaplingTable.TitleAdditionalInfoTooltipTextKey'
          )}
          avatarProps={{
            Icon: DocFlowIcon,
          }}
          extra={{
            items: [item],
          }}
          extraRules={EntityExtraTagsDocFlowRules}
          id={id}
          value={value}
        />
      )

    case DocFlowTableCellName.Phase:
      return (
        <TableTextCell
          {...restProps}
          value={t(DOC_FLOW_PHASE_TITLE_KEYS[value])}
        />
      )

    case DocFlowTableCellName.Status:
      return (
        <TableStatusCell
          {...restProps}
          statuses={DOC_FLOW_STATUSES}
          value={value}
        />
      )

    default:
      break
  }
}
